<template>
  <div class="divider" :class="[`divider-${position}`]">
    <div class="divider-bar divider-bar-before" v-if="showBeforeBar"></div>

    <h4 :is="tag" :class="[isTitle ? 'divider-title' : 'divider-text']">
      <slot>{{ title }}</slot>
    </h4>

    <div class="divider-bar divider-bar-after" v-if="showAfterBar"></div>
  </div>
</template>

<script>
export default {
  name: 'Divider',

  props: {
    tag: {
      type: String,
      default: 'h4',
      validator(value) {
        return ['h3', 'h4', 'h5', 'h6', 'p', 'span'].includes(value);
      },
    },

    title: {
      type: String,
      required: true,
    },

    position: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right', 'center'].includes(value);
      },
    },
  },

  computed: {
    isTitle() {
      return ['h3', 'h4', 'h5', 'h6'].includes(this.tag);
    },

    isCenter() {
      return this.position === 'center';
    },

    showBeforeBar() {
      return ['right', 'center'].includes(this.position);
    },

    showAfterBar() {
      return ['left', 'center'].includes(this.position);
    },
  },
};
</script>
